import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@focal/ui-kit";

interface ClientsPaginationProps {
  page: number;
  setPage: (page: number) => void;
}

export const CustomPagination = ({ page, setPage }: ClientsPaginationProps) => {
  return (
    <Pagination className="flex flex-1">
      <PaginationContent>
        {page > 0 && (
          <PaginationItem>
            <PaginationPrevious
              onClick={() => setPage(page && page - 1)}
              href="#"
            />
          </PaginationItem>
        )}
        <PaginationItem>
          <PaginationLink href="#">{page + 1}</PaginationLink>
        </PaginationItem>

        <PaginationItem>
          <PaginationNext onClick={() => setPage(page + 1)} href="#" />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
};
